import axios from 'axios';

// API Configuration - Base URL for all API calls
export const BACKEND_BASE_URL = (
  import.meta.env.VITE_APP_API_BASE_URL
).replace(/\/+$/g, "");

const baseUrl = `${BACKEND_BASE_URL}/`;
export const API_BASE_URL = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;

// Log the API configuration on module load
// console.log('🔥 === API CONFIGURATION ===');
// console.log('🔥 process.env.REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
// console.log('🔥 baseUrl (before processing):', baseUrl);
// console.log('🔥 API_BASE_URL (final):', API_BASE_URL);
// console.log('🔥 === END API CONFIGURATION ===');

// API Endpoints

export const API_ENDPOINTS = {
  LOGIN: '/auth/login',
  parameters: '/parameters',
  PATIENTS: '/patients',
  APPOINTMENTS: '/appointments',
  DOCTORS: '/doctors',
  FRONTDESK: '/frontdesk',
  ADMIN: {
    LOGIN: 'api/admin/login'
  },
  DOCTOR: {
    ALL: 'api/doctor/all',
    LOGIN: 'api/doctor/login',
    REGISTER: 'api/doctor/register',
    UPDATE: 'api/doctor/update',
    DELETE: 'api/doctor/delete',
    GET_SLOTS: 'api/doctor/getSlots',
    GET_RECOMMENDATIONS: 'api/prescription/getDoctorRecc'
  },
  PATIENT: {
    LIST: 'api/patients/getpatientlist',
    ADD: 'api/patients/AddnewPatients',
  },
  APPOINTMENT: {
    ADD: 'api/appointment/add',
    TODAY: 'api/appointment/today',
    TODAY_CLINIC: 'api/appointment/todayClinic',
    CONSULTATIONS: 'api/appointment/consultations',
    DOCTOR_CONSULTATIONS: 'api/appointment/doctorConsultations',
    GET_APPOINTMENTS_BY_DATE_RANGE_BY_DOCTOR: 'api/appointment/getAppointmentsByDateRangeByDoctor',
    TOTAL_FOR_DOCTOR: 'api/appointment/totalForDoctor',
    DOCTOR_PENDING: 'api/appointment/doctorPending',
    DOCTOR_COMPLETED: 'api/appointment/doctorCompleted'
  },
  LAB: {
    GET_REPORTS: 'api/lab/getLabReports',
    ADD: 'api/lab/add'
  },
  CHAT: {
    SEND: 'api/chat/send'
  },
  PRESCRIPTION: {
    CREATE: 'api/prescription/create',
    UPLOAD: 'api/prescription/upload',
  },
  AUDIT: {
    LOGS: 'api/audit/logs',
    EXPORT: 'api/audit/export',
    LOGIN_ACTIVITY: 'api/audit/login-activity',
    GOOGLE_AUTH_LOGS: 'api/audit/google-auth-logs',
  },
  PARAMETERS: {
    FETCH_BY_DOCTOR: 'api/parameters/fetchByDoctorId',
    ADD_APPOINTMENT: 'api/parameters/addAppointmentParameters',
    BY_APPOINTMENT: 'api/parameters/byAppointment'
  }
};

// API Headers
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : '',
  };
};

// Create an axios instance with default config
const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true'
  },
  withCredentials: false
});

// Add request interceptor for debugging
instance.interceptors.request.use(
  config => {
    // console.log('🔥 === AXIOS REQUEST INTERCEPTOR START ===');
    // console.log('🔥 Original config received:', {
    //   url: config.url,
    //   method: config.method,
    //   baseURL: config.baseURL,
    //   params: config.params,
    //   data: config.data
    // });

    // Get token from localStorage
    const token = localStorage.getItem('token');
    // console.log('🔥 Token from localStorage:', {
    //   token: token,
    //   tokenLength: token ? token.length : 0,
    //   tokenType: token ? typeof token : 'undefined',
    //   tokenPrefix: token ? token.substring(0, 7) : 'none'
    // });

    if (token) {
      // For JWT tokens, we need to add the Bearer prefix
      config.headers.Authorization = `Bearer ${token}`;
      // console.log('🔥 Authorization header set:', {
      //   header: config.headers.Authorization,
      //   headerLength: config.headers.Authorization.length,
      //   headerPrefix: config.headers.Authorization.substring(0, 7)
      // });
    } else {
      console.warn('🔥 No token found in localStorage');
    }

    // Strictly check for appointment endpoints only
    const appointmentEndpoints = [
      '/appointment/add',
      '/appointment/today',
      '/appointment/todayClinic',
      '/appointment/consultations',
      '/appointment/update',
      '/appointment/delete',
      '/appointment/updateApptStatus'
    ];

    const isAppointmentCall = appointmentEndpoints.some(endpoint => config.url.includes(endpoint));

    // Only add headers for exact appointment endpoint matches
    if (isAppointmentCall) {
      config.headers['X-Appointment-Request'] = 'true';
      config.headers['X-Request-Type'] = 'appointment';
      console.log('🔥 Added appointment headers');
    }

    // Remove Access-Control-Allow-Origin from request headers as it should be set by the server
    delete config.headers['Access-Control-Allow-Origin'];
    delete config.headers['Access-Control-Allow-Credentials'];

    // console.log('🔥 URL processing - BEFORE:', {
    //   originalUrl: config.url,
    //   baseURL: config.baseURL,
    //   isAbsoluteUrl: config.url && config.url.startsWith('http')
    // });

    // Ensure proper URL construction by removing any double slashes and leading slashes for relative URLs
    if (config.url && !config.url.startsWith('http')) {
      // Only process relative URLs, not absolute URLs
      const url = config.url.replace(/\/+/g, '/');
      // Remove leading slash for proper baseURL concatenation (baseURL already has trailing slash)
      config.url = url.startsWith('/') ? url.substring(1) : url;

      // console.log('🔥 URL processing - AFTER:', {
      //   originalUrl: originalUrl,
      //   processedUrl: config.url,
      //   baseURL: config.baseURL,
      //   finalFullUrl: config.baseURL + config.url
      // });
    }

    // Log the final request configuration
    // console.log('🔥 Final request config:', {
    //   url: config.url,
    //   method: config.method,
    //   headers: config.headers,
    //   baseURL: config.baseURL,
    //   fullURL: config.baseURL + config.url,
    //   withCredentials: config.withCredentials,
    //   params: config.params
    // });

    // console.log('🔥 === AXIOS REQUEST INTERCEPTOR END ===');
    return config;
  },
  error => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging
instance.interceptors.response.use(
  response => {
    // console.log('🔥 === AXIOS RESPONSE INTERCEPTOR START ===');
    // console.log('🔥 Response received:', {
    //   url: response.config.url,
    //   fullURL: response.config.baseURL + response.config.url,
    //   method: response.config.method,
    //   status: response.status,
    //   statusText: response.statusText,
    //   headers: response.headers,
    //   data: response.data,
    //   requestHeaders: response.config.headers
    // });
    // console.log('🔥 === AXIOS RESPONSE INTERCEPTOR END ===');
    return response;
  },
  error => {
    // console.log('🔥 === AXIOS ERROR INTERCEPTOR START ===');
    console.error('🔥 Response error:', {
      url: error.config?.url,
      fullURL: error.config ? (error.config.baseURL + error.config.url) : 'unknown',
      method: error.config?.method,
      status: error.response?.status,
      message: error.message,
      response: error.response?.data,
      requestHeaders: error.config?.headers,
      responseHeaders: error.response?.headers
    });
    // console.log('🔥 === AXIOS ERROR INTERCEPTOR END ===');

    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('tokenPayload');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const axiosInstance = instance;
export default API_BASE_URL;
